import { useState } from "react";
import { X } from "lucide-react";

const SHARE_TEXT =
  "Ho giocato alla demo ufficiale de Il mondo di Jane Austen! Aiutiamo Land Editore a realizzare il videogioco completo: gioca e condividi anche tu.";

export default function ShareModal({ open, onClose }) {
  const [toast, setToast] = useState(null);
  if (!open) return null;
  const shareUrl = window.location.origin + window.location.pathname;

  const copyLink = async (msg) => {
    const full = `${SHARE_TEXT} ${shareUrl}`;
    try {
      await navigator.clipboard.writeText(full);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = full; ta.style.position = "fixed"; ta.style.opacity = "0";
      document.body.appendChild(ta); ta.select();
      try { document.execCommand("copy"); } catch {}
      document.body.removeChild(ta);
    }
    setToast(msg);
    setTimeout(() => setToast(null), 3400);
  };

  const wa = () => window.open(`https://wa.me/?text=${encodeURIComponent(SHARE_TEXT + " " + shareUrl)}`, "_blank", "noopener");
  const fb = () => window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`, "_blank", "noopener");
  const ms = () => {
    if (/iphone|ipad|ipod|android/i.test(navigator.userAgent)) {
      try { window.location.href = `fb-messenger://share?link=${encodeURIComponent(shareUrl)}`; } catch {}
    }
    copyLink("Link copiato! Apri Messenger e incollalo nella conversazione.");
  };
  const em = () => {
    const subject = "Devi provare questo videogioco di Jane Austen!";
    const body =
      "Ho giocato alla demo ufficiale de Il mondo di Jane Austen. Questa è soltanto la prima avventura: se avrà abbastanza condivisioni, Land Editore realizzerà il videogioco completo. Provalo qui: " + shareUrl;
    window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };
  const native = async () => {
    if (navigator.share) {
      try { await navigator.share({ title: "Il mondo di Jane Austen – Demo", text: SHARE_TEXT, url: shareUrl }); return; } catch { return; }
    }
    copyLink("Link copiato! Condividilo ovunque.");
  };
  const copy = () => copyLink("Link copiato! Condividilo ovunque.");

  return (
    <div className="share-overlay" data-testid="share-modal" onClick={onClose}>
      <div className="share-card" onClick={(e) => e.stopPropagation()}>
        <button className="ios-close" onClick={onClose} data-testid="share-close" aria-label="Chiudi"><X size={20} /></button>
        <h2 className="share-title">Condividi la prima avventura</h2>
        <p className="share-text">Aiutaci a realizzare il videogioco completo: condividi la demo con tutti gli amanti di Jane Austen.</p>
        <div className="share-grid">
          <button className="share-item wa" onClick={wa} data-testid="share-whatsapp"><i className="fa-brands fa-whatsapp" /><span>WhatsApp</span></button>
          <button className="share-item fb" onClick={fb} data-testid="share-facebook"><i className="fa-brands fa-facebook-f" /><span>Facebook</span></button>
          <button className="share-item ms" onClick={ms} data-testid="share-messenger"><i className="fa-brands fa-facebook-messenger" /><span>Messenger</span></button>
          <button className="share-item em" onClick={em} data-testid="share-email"><i className="fa-solid fa-envelope" /><span>Email</span></button>
          <button className="share-item nt" onClick={native} data-testid="share-native"><i className="fa-solid fa-share-nodes" /><span>Altre app</span></button>
          <button className="share-item cp" onClick={copy} data-testid="share-copy"><i className="fa-solid fa-link" /><span>Copia link</span></button>
        </div>
      </div>
      {toast && <div className="shell-toast" data-testid="share-toast">{toast}</div>}
    </div>
  );
}
